/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setField } from '../helpers/savedSearches';

export const rename = createAsyncThunk(
  'savedSearches/rename',
  async (
    { _id, name },
    {
      extra: { sdk, Logger, Toast },
    },
  ) => {
    try {
      await sdk.savedSearches.rename(_id, name);

      return { _id, name };
    } catch (error) {
      Logger.error(new Error('Can not rename saved search'), { error }, [
        'RenameSavedSearchesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error renaming saved search', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    rename.pending,
    (state, { meta: { arg: { _id } } }) => {
      state.tree = setField(state.tree, _id, 'isBusy', true);
    },
  ).addCase(
    rename.fulfilled,
    (state, { payload: { _id, name } }) => {
      state.all = state.all.map((ss) => {
        if (ss._id !== _id) return ss;
        return { ...ss, name };
      });
      state.tree = setField(state.tree, _id, ['name', 'isBusy'], [name, false]);
    },
  ).addCase(
    rename.rejected,
    (state, { error, meta: { arg: { _id } } }) => {
      state.error = error;
      state.tree = setField(state.tree, _id, 'isBusy', false);
    },
  );
};
